// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mobile-phone';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M11.453.563H5.828a2.25 2.25 0 0 0-2.25 2.25v12.374a2.25 2.25 0 0 0 2.25 2.25h5.625a2.25 2.25 0 0 0 2.25-2.25V2.813a2.25 2.25 0 0 0-2.25-2.25zm-7.875 12.75h10.125'
  />
);

export const viewBox = '0 0 18 18';
